<template>
    <div class="layout">
        <Row :gutter="20">
            <Col :span="readOnly ? 22 : 18">
                <Form
                    ref="fromRef"
                    :model="invoiceForm"
                    :rules="invoiceFormRules"
                    :label-width="110">
                    <Row>
                        <Col :span="8">
                            <!--库存组织-->
                            <FormItem :label="$t('createDeliveryOrderByOrder.t1')" prop="organizationCode">
                                <Select
                                    v-model="invoiceForm.organizationCode"
                                    :disabled="readOnly"
                                    size="small"
                                    :filterable="true"
                                    :clearable="true"
                                    @on-change="orgOnChange">
                                    <Option v-for="item in orgList" :value="item.value" :key="item.value">{{item.label}}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col :span="8">
                            <!--供应商编码-->
                            <FormItem :label="$t('UIDLabelPrint.t27')" prop="vendorCode">
                                <Input type="text" size="small" disabled v-model="invoiceForm.vendorCode"></Input>
                            </FormItem>
                        </Col>
                        <Col :span="8">
                            <!--供应商名称-->
                            <FormItem :label="$t('importNoticeCommon.t26')" prop="vendorName">
                                <Input type="text" size="small" disabled v-model="invoiceForm.vendorName"></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col :span="8">
                            <!--币种-->
                            <FormItem :label="$t('gscInvoice.t17')" prop="currency">
                                <Select
                                    v-model="invoiceForm.currency"
                                    size="small"
                                    :disabled="readOnly"
                                    :filterable="true">
                                    <Option v-for="item in INT_CURRENCY" :value="item.value" :key="item.value">{{item.label}}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col :span="8">
                            <!--单据号-->
                            <FormItem :label="$t('typeTestProcessSearch.t7')" prop="headerNum">
                                <Input type="text" size="small" disabled v-model="invoiceForm.headerNum"></Input>
                            </FormItem>
                        </Col>
                        <Col :span="8">
                            <!--(总)物料数量-->
                            <FormItem :label="$t('commercialInvoice.t13')" prop="totalQty">
                                <Input type="text" size="small" disabled v-model="invoiceForm.totalQty"></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col :span="8">
                            <!--(总)金额-->
                            <FormItem :label="$t('commercialInvoice.t14')" prop="totalPrice">
                                <Input type="text" size="small" disabled v-model="invoiceForm.totalPrice"></Input>
                            </FormItem>
                        </Col>
                        <Col :span="8">
                           <!--状态-->
                            <FormItem :label="$t('gscInvoice.t62')" prop="vendorStatus">
                                <Select
                                    v-model="invoiceForm.vendorStatus"
                                    size="small"
                                    disabled>
                                    <Option v-for="item in INT_COMMERCIAL_INVOICE_STATUS" :value="item.value" :key="item.value">{{item.label}}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col :span="8">
                            <!--创建日期-->
                            <FormItem :label="$t('UIDLabelPrint.t32')" prop="creationDate">
                                <Input type="text" size="small" disabled v-model="invoiceForm.creationDate"></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col :span="8">
                            <!--拒绝原因-->
                            <FormItem :label="$t('deliveryNoticeConfirm.t33')" prop="rejectReason">
                                <Input type="text" size="small" disabled v-model="invoiceForm.rejectReason"></Input>
                            </FormItem>
                        </Col>
                        <Col :span="24">
                            <!--备注-->
                            <FormItem :label="$t('HSInspectManageMat.t7')" prop="remark">
                                <Input type="textarea" size="small" :disabled="readOnly" v-model="invoiceForm.remark"></Input>
                            </FormItem>
                        </Col>
                        <Col :span="24">
                            <!--附件-->
                            <FormItem :label="$t('approval.UploadAttachments')">
                                <Upload
                                    action="/gscint/supplierfile/uploadFile"
                                    ref="uploadFileRef"
                                    :multiple="true"
                                    :show-upload-list="false"
                                    :before-upload="beforeUpload"
                                    :on-progress="uploadProgress"
                                    :on-success="uploadSuccess">
                                    <!-- 选择上传文件 -->
                                    <Button type="ghost" icon="ios-cloud-upload-outline" :loading="uploadLoading" :disabled="readOnly">{{$t('importNoticeCommon.t30')}}</Button>
                                </Upload>
                            </FormItem>
                        </Col>
                        <Col :span="24">
                            <div style="margin:10px 0 0 90px;" v-for="item in attachmentList" :key="item.docId">
                                <Button style="color: #0077FF;" type="text" @click="downloadById(item.docId)">{{item.docName}}</Button>
                                <Button v-if="!readOnly" type="error" size="small" @click="deleteFileById(item.docId)">{{$t('common.delBtn')}}</Button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </Col>
            <Col :span="readOnly ? 2 : 6">
                <template v-if="!readOnly">
                    <!--保存-->
                    <Button type="primary" :loading="loading" :disabled="saveDisabled" @click="saveOrUpdate">{{$t('common.saveBtn')}}</Button>
                    <!--提交-->
                    <Button type="primary" :loading="loading" :disabled="saveDisabled" @click="saveOrUpdate(false)" class="ml10">{{$t('common.commit')}}</Button>
                </template>
                <!--返回-->
                <Button class="ml10" @click="back">{{$t('common.back')}}</Button>
            </Col>
        </Row>

        <Table
            class="mt10 w600"
            thDrag
            highlight-row
            border
            :columns="summarizingMod.columns"
            :data="summarizingMod.tableData"
            :loading="summarizingMod.loading">
        </Table>

        <div class="mt10">
                <template v-if="!readOnly">
                    <!--新增-->
                    <Button type="primary" @click="addLine">{{$t('common.newBtn')}}</Button>
                    <!--复制-->
                    <Button type="primary" class="ml10" :disabled="linesMod.tableData.length === 0" @click="copyLine">{{$t('commercialInvoice.t18')}}</Button>
                    <!--删除-->
                    <Button :disabled="linesMod.selection.length === 0" class="ml10" type="error" @click="deleteLine">{{$t('common.delBtn')}}</Button>
                </template>
                    <!--导出-->
                    <a id="anchor" @click="exportLines(true)"><Button :disabled="linesMod.tableData.length === 0" class="ml10" type="primary">{{$t('common.export')}}</Button></a>
                <template v-if="!readOnly">
                    <!--导入-->
                    <Button class="ml10" type="primary" @click="importFun">{{$t('importNoticeCommon.t100')}}</Button>
                </template>
        </div>

        <Table
            class="mt10"
            thDrag
            highlight-row
            border
            :columns="linesMod.columns"
            :data="linesMod.tableData"
            :loading="linesMod.loading"
            @on-selection-change="onSelectionChange">
        </Table>

        <!--物料编码-->
        <Modal
            :title="$t('gscInvoice.t50')"
            v-model="itemCodeModal.show"
            :width="600"
            :mask-closable="false">
            <Form
                ref="itemCodeFormRef"
                :model="itemCodeModal.form"
                :label-width="100">
                <Row>
                    <Col :span="9">
                        <FormItem :label="$t('gscInvoice.t50')">
                            <Input
                                size="small"
                                v-model.trim="itemCodeModal.form.itemCode">
                            </Input>
                        </FormItem>
                    </Col>
                    <Col :span="9">
                        <FormItem :label="$t('gscInvoice.t51')">
                            <Input
                                size="small"
                                v-model.trim="itemCodeModal.form.itemDesc">
                            </Input>
                        </FormItem>
                    </Col>
                    <Col :span="1">
                        &nbsp;
                    </Col>
                    <Col :span="5">
                        <Button type="primary" :loading="itemCodeModal.loading" @click="getItemList">{{$t('page.query.search')}}</Button>
                    </Col>
                </Row>
            </Form>
            <Table
                v-if="itemCodeModal.show"
                ref="itemCodeTableRef"
                size="small"
                thDrag
                highlight-row
                border
                :loading="itemCodeModal.loading"
                :columns="itemCodeModal.columns"
                :data="itemCodeModal.tableData"
                @on-row-click="itemCodeRowClick">
            </Table>
            <Page
                :total="itemCodeModal.total"
                show-elevator
                show-total
                size="small"
                transfer
                @on-change="itemCodeOnPageChange"
                placement="top" />
            <template slot="footer">
                <Button type="primary" :disabled="!itemCodeModal.row" @click="itemCodeOnConfirm">{{$t('common.confirmBtn')}}</Button>
            </template>
        </Modal>

        <Modal
            v-model="importModal.show"
            :width="400">
            <Upload
                action="/gscint/excel/loadExcelData"
                ref="importUploadFileRef"
                :multiple="true"
                :data="uploadData"
                :show-upload-list="false"
                :before-upload="beforeUpload"
                :on-progress="importUploadProgress"
                :on-success="importUploadSuccess">
                <!-- 选择上传文件 -->
                <Button type="ghost" icon="ios-cloud-upload-outline" :loading="importModal.loading">{{$t('importNoticeCommon.t30')}}</Button>
            </Upload>
            <p style="color:red;margin:10px 0;">{{$t('gscInt.import.tips1')}}</p>
            <a id="anchor2" @click="importTemplate"><Button type="primary">{{$t('gscInt.import.downTemp')}}</Button></a>
            <div slot="footer"></div>
        </Modal>

        <!--品牌产地-->
        <Modal
            v-model="brandModal.show"
            :title="$t('品牌产地')"
            :width="600">
            <Table
                v-if="brandModal.show"
                size="small"
                thDrag
                highlight-row
                border
                :loading="brandModal.loading"
                :columns="brandModal.columns"
                :data="brandModal.tableData"
                @on-row-click="brandRowClick">
            </Table>
            <div slot="footer">
                <Button type="primary" :loading="brandModal.loading" :disabled="!brandModal.row" @click="brandConfirm">{{$t('common.confirmBtn')}}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import moment from 'moment';
import ExcellentExport from 'excellentexport';
import axios from 'axios';
import { langParams } from '@/utils/tool';
import BigNumber from 'bignumber.js';
import mixin from './index';

export default {
    name: 'common',
    mixins: [mixin],
    props: {
        readOnly: {
            type: Boolean,
            default: () => false,
        },
    },
    computed: {
        headerId() {
            return this.$route.query.headerId || this.invoiceForm.headerId;
        },
        saveDisabled() {
            return this.linesMod.tableData.length === 0;
        },
        uploadData() {
            return {
                keyValue: JSON.stringify(this.linesMod.columns.filter((item) => item.key && !['unitPrice', 'price'].includes(item.key)).map((item) => {
                    return {
                        key: item.title,
                        value: item.key,
                    };
                })),
            };
        },
        /* 小数位限制 */
        decimalPlaceRestrictionRule() {
            return new RegExp(`^-?(?:\\d+(?:\\.\\d{1,${this.decimalPlaces}})?)$`);
        },
        decimalPlacesWarning() {
            return `${this.$t('gscInvoice.t102') + this.$t('gscInvoice.t124') + this.decimalPlaces + this.$t('gscInvoice.t125')}`;
        },
        numWarning() {
            return `${this.$t('importNoticeCommon.t131') + this.$t('gscInvoice.t124') + this.decimalPlaces + this.$t('gscInvoice.t125')}`;
        },
    },
    data() {
        return {
            invoiceForm: {
                headerId: '',
                organizationCode: '',
                invoiceNumber: '',
                invoiceDate: '',
                currency: '',
                remark: '',
                vendorStatus: 'DRAFT',
                totalQty: 0,
                totalPrice: 0,
                rejectReason: '',
            },
            loading: false,
            invoiceFormRules: {
                organizationCode: [
                    {
                        required: true, message: this.$t('createDeliveryOrderByOrder.t1') + this.$t('gscInvoice.t104'), trigger: 'change',
                    },
                ],
                currency: [
                    {
                        required: true, message: this.$t('gscInvoice.t17') + this.$t('gscInvoice.t104'), trigger: 'change',
                    },
                ],
                // invoiceNumber: [
                //     {
                //         required: true, message: this.$t('commercialInvoice.t1') + this.$t('gscInvoice.t104'), trigger: 'change',
                //     },
                // ],
                // invoiceDate: [
                //     {
                //         required: true, type: 'date', message: this.$t('importNoticeCommon.t45') + this.$t('gscInvoice.t104'), trigger: 'change',
                //     },
                // ],
            },
            orgList: [],
            uploadLoading: false,
            summarizingMod: {
                columns: [
                    {
                        title: this.$t('gscInvoice.t50'), // 物料编码
                        key: 'itemCode',
                        minWidth: 110,
                    },
                    {
                        title: this.$t('gscInvoice.t51'), // 物料描述
                        key: 'itemDesc',
                        minWidth: 200,
                        tooltip: true,
                    },
                    {
                        title: this.$t('gscInvoice.t54'), // 数量
                        key: 'qty',
                        minWidth: 60,
                        align: 'right',
                    },
                    {
                        title: this.$t('commercialInvoice.t15'), // 总价
                        key: 'price',
                        minWidth: 60,
                        align: 'right',
                    },
                ],
                tableData: [],
                loading: false,
            },
            linesMod: {
                columns: [
                    {
                        type: 'selection',
                        width: 35,
                        align: 'center',
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: '#FF0000',
                                    },
                                }, '* '),
                                h('span', this.$t('DeliveryOrderQuery.t57')),
                            ]);
                        },
                        title: this.$t('DeliveryOrderQuery.t57'), // 发票号
                        key: 'invoiceNumber',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => {
                            if (this.readOnly) {
                                return h('span', params.row.invoiceNumber);
                            }
                            return h('Input', {
                                props: {
                                    size: 'small',
                                    value: params.row.invoiceNumber,
                                },
                                style: {
                                    width: '100%',
                                },
                                on: {
                                    'on-blur': (event) => {
                                        const { value } = event.target;
                                        params.row.invoiceNumber = value;
                                        this.linesMod.tableData[params.index] = params.row;
                                    },
                                },
                            });
                        },
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: '#FF0000',
                                    },
                                }, '* '),
                                h('span', this.$t('importNoticeCommon.t45')),
                            ]);
                        },
                        title: this.$t('importNoticeCommon.t45'), // 发票日期
                        key: 'invoiceDate',
                        minWidth: 110,
                        align: 'center',
                        render: (h, params) => {
                            if (this.readOnly) {
                                return h('span', params.row.invoiceDate);
                            }
                            return h('DatePicker', {
                                props: {
                                    type: 'date',
                                    size: 'small',
                                    value: params.row.invoiceDate,
                                    format: 'yyyy-MM-dd',
                                    transfer: true,
                                    editable: false,
                                    options: {
                                        disabledDate(date) {
                                            return date && date.valueOf() > Date.now();
                                        },
                                    },
                                },
                                on: {
                                    'on-change': (date) => {
                                        params.row.invoiceDate = date;
                                        this.linesMod.tableData[params.index] = params.row;
                                    },
                                    'on-clear': () => {
                                        params.row.invoiceDate = '';
                                        this.linesMod.tableData[params.index] = params.row;
                                    },
                                },
                            });
                        },
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: '#FF0000',
                                    },
                                }, '* '),
                                h('span', this.$t('commercialInvoice.t3')),
                            ]);
                        },
                        title: this.$t('commercialInvoice.t3'), // 实际柜号
                        key: 'cont',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => {
                            if (this.readOnly) {
                                return h('span', params.row.cont);
                            }
                            return h('Input', {
                                props: {
                                    size: 'small',
                                    value: params.row.cont,
                                },
                                style: {
                                    width: '100%',
                                },
                                on: {
                                    'on-blur': (event) => {
                                        const { value } = event.target;
                                        params.row.cont = value;
                                        this.linesMod.tableData[params.index] = params.row;
                                    },
                                },
                            });
                        },
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: '#FF0000',
                                    },
                                }, '* '),
                                h('span', this.$t('importNoticeCommon.t118')),
                            ]);
                        },
                        title: this.$t('importNoticeCommon.t118'), // 箱号
                        key: 'ctn',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => {
                            if (this.readOnly) {
                                return h('span', params.row.ctn);
                            }
                            return h('Input', {
                                props: {
                                    size: 'small',
                                    value: params.row.ctn,
                                },
                                style: {
                                    width: '100%',
                                },
                                on: {
                                    'on-blur': (event) => {
                                        const { value } = event.target;
                                        params.row.ctn = value;
                                        this.linesMod.tableData[params.index] = params.row;
                                    },
                                },
                            });
                        },
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: '#FF0000',
                                    },
                                }, '* '),
                                h('span', this.$t('invoiceMonitoring.t2')),
                            ]);
                        },
                        title: this.$t('invoiceMonitoring.t2'), // 物料编码
                        key: 'itemCode',
                        minWidth: 110,
                        align: 'center',
                        render: (h, params) => {
                            if (this.readOnly) {
                                return h('span', params.row.itemCode);
                            }
                            return h('Input', {
                                props: {
                                    size: 'small',
                                    value: params.row.itemCode,
                                    readOnly: true,
                                    icon: 'search',
                                },
                                style: {
                                    width: '100%',
                                },
                                on: {
                                    'on-click': () => {
                                        Object.assign(this.itemCodeModal, {
                                            show: true,
                                            rowIndex: params.index,
                                            type: 'table',
                                        });
                                    },
                                },
                            });
                        },
                    },
                    {
                        title: this.$t('importNoticeCommon.t18'), // 物料描述
                        key: 'itemDesc',
                        minWidth: 150,
                        tooltip: true,
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: '#FF0000',
                                    },
                                }, '* '),
                                h('span', this.$t('importNoticeCommon.t119')),
                            ]);
                        },
                        title: this.$t('importNoticeCommon.t119'), // 品牌
                        key: 'brand',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => {
                            if (this.readOnly) {
                                return h('span', params.row.brand);
                            }
                            return h('Input', {
                                props: {
                                    size: 'small',
                                    value: params.row.brand,
                                    // icon: 'search',
                                },
                                style: {
                                    width: '100%',
                                },
                                on: {
                                    'on-blur': (event) => {
                                        const { value } = event.target;
                                        params.row.brand = value;
                                        this.linesMod.tableData[params.index] = params.row;
                                    },
                                    // 'on-click': () => {
                                    //     debugger;
                                    //     const { itemCode } = params.row;
                                    //     if (!itemCode) {
                                    //         this.$Modal.warning({
                                    //             content: this.$t('UIDLabelPrint.t5'),
                                    //         });
                                    //         return;
                                    //     }
                                    //     Object.assign(this.brandModal, {
                                    //         show: true,
                                    //         index: params.index,
                                    //     });
                                    //     this.getBrandPlaceInfo([itemCode]);
                                    // },
                                },
                            });
                        },
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: '#FF0000',
                                    },
                                }, '* '),
                                h('span', this.$t('commercialInvoice.t16')),
                            ]);
                        },
                        title: this.$t('commercialInvoice.t16'), // 产地
                        key: 'origin',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => {
                            if (this.readOnly) {
                                return h('span', params.row.origin);
                            }
                            return h('Input', {
                                props: {
                                    size: 'small',
                                    value: params.row.origin,
                                },
                                style: {
                                    width: '100%',
                                },
                                on: {
                                    'on-blur': (event) => {
                                        const { value } = event.target;
                                        params.row.origin = value;
                                        this.linesMod.tableData[params.index] = params.row;
                                    },
                                },
                            });
                        },
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: '#FF0000',
                                    },
                                }, '* '),
                                h('span', this.$t('VendorRegist.vrcolumn61') + '(KG)'),
                            ]);
                        },
                        title: this.$t('VendorRegist.vrcolumn61') + '(KG)', // 数量
                        key: 'singQty',
                        minWidth: 80,
                        align: 'right',
                        render: (h, params) => {
                            const fun = () => {
                                this.linesMod.tableData[params.index] = params.row;
                                this.countFun(params.index, params.row);
                                this.itemCodeCount();
                            };
                            if (this.readOnly) {
                                return h('span', params.row.singQty);
                            }
                            return h('InputNumber', {
                                props: {
                                    size: 'small',
                                    value: params.row.singQty,
                                    min: 0,
                                },
                                style: {
                                    width: '100%',
                                },
                                on: {
                                    'on-change': (val) => {
                                        params.row.singQty = val;
                                        fun();
                                    },
                                    'on-blur': () => {
                                        let val = params.row.singQty;
                                        if (!this.decimalPlaceRestrictionRule.test(val) || val === 0) {
                                            if (val || val === 0) {
                                                this.$Modal.error({
                                                    content: this.numWarning,
                                                });
                                            }
                                            params.row.singQty = '';
                                            fun();
                                        }
                                    },
                                },
                            });
                        },
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: '#FF0000',
                                    },
                                }, '* '),
                                h('span', this.$t('commercialInvoice.t5') + '(KG)'),
                            ]);
                        },
                        title: this.$t('commercialInvoice.t5') + '(KG)', // 净重(KG)
                        key: 'netWeight',
                        minWidth: 80,
                        align: 'right',
                        render: (h, params) => {
                            if (this.readOnly) {
                                return h('span', params.row.netWeight);
                            }
                            return h('InputNumber', {
                                props: {
                                    size: 'small',
                                    value: params.row.netWeight,
                                    min: 0,
                                },
                                style: {
                                    width: '100%',
                                },
                                on: {
                                    'on-change': (val) => {
                                        params.row.netWeight = val;
                                        this.linesMod.tableData[params.index] = params.row;
                                    },
                                },
                            });
                        },
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: '#FF0000',
                                    },
                                }, '* '),
                                h('span', this.$t('importNoticeCommon.t163') + '(KG)'),
                            ]);
                        },
                        title: this.$t('importNoticeCommon.t163') + '(KG)', // 毛重(KG)
                        key: 'grossWeight',
                        minWidth: 80,
                        align: 'right',
                        render: (h, params) => {
                            if (this.readOnly) {
                                return h('span', params.row.grossWeight);
                            }
                            return h('InputNumber', {
                                props: {
                                    size: 'small',
                                    value: params.row.grossWeight,
                                    min: 0,
                                },
                                style: {
                                    width: '100%',
                                },
                                on: {
                                    'on-change': (val) => {
                                        params.row.grossWeight = val;
                                        this.linesMod.tableData[params.index] = params.row;
                                        // this.countFun();
                                    },
                                },
                            });
                        },
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: '#FF0000',
                                    },
                                }, '* '),
                                h('span', this.$t('commercialInvoice.t7') + '(MT)'),
                            ]);
                        },
                        title: this.$t('commercialInvoice.t7') + '(MT)', // 铜价
                        key: 'copperPrice',
                        minWidth: 80,
                        align: 'right',
                        render: (h, params) => {
                            const fun = () => {
                                this.linesMod.tableData[params.index] = params.row;
                                this.countFun(params.index, params.row);
                                this.itemCodeCount();
                            };
                            if (this.readOnly) {
                                return h('span', params.row.copperPrice);
                            }
                            return h('InputNumber', {
                                props: {
                                    size: 'small',
                                    value: params.row.copperPrice,
                                    min: 0,
                                },
                                style: {
                                    width: '100%',
                                },
                                on: {
                                    'on-change': (val) => {
                                        params.row.copperPrice = val;
                                        fun();
                                    },
                                    'on-blur': () => {
                                        let val = params.row.copperPrice;
                                        if (!this.decimalPlaceRestrictionRule.test(val) || val === 0) {
                                            if (val || val === 0) {
                                                this.$Modal.error({
                                                    content: this.decimalPlacesWarning,
                                                });
                                            }
                                            params.row.copperPrice = '';
                                            fun();
                                        }
                                    },
                                },
                            });
                        },
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: '#FF0000',
                                    },
                                }, '* '),
                                h('span', this.$t('commercialInvoice.t8') + '(MT)'),
                            ]);
                        },
                        title: this.$t('commercialInvoice.t8') + '(MT)', // 加工费
                        key: 'fabricationFee',
                        minWidth: 80,
                        align: 'right',
                        render: (h, params) => {
                            const fun = () => {
                                this.linesMod.tableData[params.index] = params.row;
                                this.countFun(params.index, params.row);
                                this.itemCodeCount();
                            };
                            if (this.readOnly) {
                                return h('span', params.row.fabricationFee);
                            }
                            return h('InputNumber', {
                                props: {
                                    size: 'small',
                                    value: params.row.fabricationFee,
                                    min: 0,
                                },
                                style: {
                                    width: '100%',
                                },
                                on: {
                                    'on-change': (val) => {
                                        params.row.fabricationFee = val;
                                        fun();
                                    },
                                    'on-blur': () => {
                                        let val = params.row.fabricationFee;
                                        if (!this.decimalPlaceRestrictionRule.test(val) || val === 0) {
                                            if (val || val === 0) {
                                                this.$Modal.error({
                                                    content: this.decimalPlacesWarning,
                                                });
                                            }
                                            params.row.fabricationFee = '';
                                            fun();
                                        }
                                    },
                                },
                            });
                        },
                    },
                    {
                        title: this.$t('fpzPenalty.t19') + '(KG)', // 单价
                        key: 'unitPrice',
                        minWidth: 80,
                        align: 'right',
                    },
                    {
                        title: this.$t('gscInvoice.t55'), // 金额
                        key: 'price',
                        minWidth: 80,
                        align: 'right',
                    },
                ],
                tableData: [],
                selection: [],
                loading: false,
            },
            deletedLineIdList: [],
            invoiceDateOptions: {
                disabledDate(date) {
                    const time = date && date.valueOf();
                    return time > Date.now() || time < Date.now() - 86400000 * 365;
                },
            },
            attachmentList: [],
            importModal: {
                show: false,
                loading: false,
            },
            decimalPlaces: 6,
            brandModal: {
                show: false,
                columns: [
                    {
                        title: this.$t('UIDLabelPrint.t26'),
                        type: 'index',
                        width: 35,
                        align: 'center',
                    },
                    {
                        title: `${this.$t('importNoticeCommon.t119')} - ${this.$t('commercialInvoice.t4')}`, // 品牌 - 原产国
                        key: 'brandPlace',
                        minWidth: 120,
                    },
                    {
                        title: this.$t('importNoticeCommon.t119'), // 品牌
                        key: 'brandName',
                        minWidth: 100,
                    },
                    {
                        title: this.$t('commercialInvoice.t4'), // 原产国
                        key: 'place',
                        minWidth: 100,
                    },
                ],
                tableData: [],
                loading: false,
                index: 0,
                row: null,
            },
            INT_ORIGIN: [],
        };
    },
    methods: {
        beforeUpload(file) {
            if (file.size > 60 * 1024 * 1024) {
                this.$Message.warning({
                    title: this.$t('common.warn'),
                    content: this.$t('importNoticeCommon.t79'), // 文件大小不能超过60M！
                });
                return false;
            }
        },
        uploadProgress() {
            this.uploadLoading = true;
        },
        uploadSuccess(res) {
            this.uploadLoading = false;
            const { docId, fileName: docName } = res.data;
            if (docId) {
                this.attachmentList.push({
                    docId,
                    docName,
                });
            }
        },
        addLine() {
            this.$refs.fromRef.validate((valid) => {
                if (valid) {
                    this.linesMod.tableData.push({
                        lineId: Date.now(),
                        cont: '',
                        ctn: '',
                        itemCode: '',
                        itemDesc: '',
                        brand: '',
                        origin: '',
                        singQty: 0,
                        netWeight: '',
                        copperPrice: '',
                        fabricationFee: '',
                        unitPrice: 0,
                        price: 0,
                        grossWeight: '',
                        isNew: true,
                    });
                }
            });
        },
        /* 计算单价、金额 */
        countFun(index, row) {
            const { copperPrice, fabricationFee, singQty } = row;
            const unitPrice = BigNumber(copperPrice || 0).plus(fabricationFee || 0).dividedBy(1000).toNumber();
            const price = BigNumber(unitPrice || 0).times(singQty || 0).toNumber();
            this.linesMod.tableData[index].unitPrice = !this.decimalPlaceRestrictionRule.test(unitPrice) ? unitPrice.toFixed(6) : unitPrice;
            this.linesMod.tableData[index].price = !this.decimalPlaceRestrictionRule.test(price) ? price.toFixed(6) : price;
        },
        back() {
            this.$router.push({
                name: 'commercialInvoice',
            });
        },
        lineValidate() {
            const requiredKeys = ['invoiceNumber', 'invoiceDate', 'cont', 'ctn', 'itemCode', 'brand', 'origin', 'singQty', 'netWeight', 'grossWeight', 'copperPrice', 'fabricationFee'];
            const columnsLabels = this.linesMod.columns.filter((item) => requiredKeys.includes(item.key)).map((item) => item.title);
            const errorTips = this.linesMod.tableData.reduce((prev, next, index) => {
                const tips = [];
                // eslint-disable-next-line no-restricted-syntax
                for (const i in next) {
                    if (next.hasOwnProperty(i)) {
                        if (!next[i] && requiredKeys.includes(i)) {
                            tips.push(columnsLabels[requiredKeys.findIndex((key) => key === i)]);
                        }
                    }
                }
                if (tips.length) {
                    prev.push(`${this.$t('page.pagination.pThe')}${index + 1}${this.$t('importNoticeCommon.t76')}，${tips.join('、')}${this.$t('gscInvoice.t104')}`);
                }
                return prev;
            }, []);
            if (errorTips.length > 0) {
                this.$Modal.warning({
                    content: errorTips.join(''),
                });
                return true;
            }
            return false;
        },
        saveOrUpdate(onlySave = true) {
            this.$refs.fromRef.validate((valid) => {
                if (valid) {
                    if (this.lineValidate()) return;
                    this.loading = true;
                    const lineList = this.linesMod.tableData.map((item) => {
                        if (item.isNew) {
                            item.lineId = '';
                        }
                        return item;
                    });
                    axios.post('/gscint/cgzxInvoice/saveOrUpdate', {
                        header: {
                            ...this.invoiceForm,
                            invoiceDate: moment(this.invoiceForm.invoiceDate).format('YYYY-MM-DD'),
                            attachmentList: this.attachmentList,
                        },
                        lineList,
                        deletedLineIdList: this.deletedLineIdList,
                    })
                        .then((res) => {
                            const { code, data, message: content } = res.data.data;
                            if (code === 1) {
                                if (onlySave) {
                                    this.queryDetail(data);
                                    this.$Modal.success({
                                        content: this.$t('common.save_success'),
                                    });
                                } else {
                                    this.submit([data]);
                                }
                            } else {
                                this.$Modal.warning({
                                    content,
                                });
                            }
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            });
        },
        submit(idList) {
            this.loading = true;
            axios.post('/gscint/cgzxInvoice/submit', {
                idList,
            })
                .then((res) => {
                    const { code, message: content } = res.data.data;
                    if (code === 1) {
                        this.$Modal.success({
                            content: this.$t('gscInvoice.t101'),
                        });
                        this.$closeTab({
                            name: this.headerId ? 'commercialInvoiceEdit' : 'commercialInvoiceAdd',
                        });
                        this.$router.push({
                            name: 'commercialInvoiceDetail',
                            query: {
                                headerId: idList[0],
                            },
                        });
                    } else {
                        this.$Modal.warning({
                            content,
                        });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        orgOnChange() {
            this.linesMod.tableData = [];
        },
        downloadById(docId) {
            window.open(`/gscint/supplierfile/downloadFile?docId=${docId}`);
        },
        deleteFileById(docId) {
            this.$Modal.confirm({
                content: this.$t('gscInvoice.t107'), // 确定要删除吗？
                onOk: () => {
                    this.attachmentList = this.attachmentList.filter((item) => item.docId !== docId);
                },
            });
        },
        queryDetail(id) {
            axios.get('/gscint/cgzxInvoice/queryDetail', {
                params: {
                    id,
                    language: langParams(this.$i18n.locale),
                },
            })
                .then((res) => {
                    const { code, data } = res.data.data;
                    if (code === 1) {
                        const { header, lineList, summaryLineList } = data;
                        Object.assign(this.invoiceForm, {
                            ...header,
                            invoiceDate: new Date(header.invoiceDate).getTime(),
                        });
                        this.summarizingMod.tableData = summaryLineList;
                        this.attachmentList = header.attachmentList;
                        this.$nextTick(() => {
                            this.linesMod.tableData = lineList;
                        });
                    }
                });
        },
        itemCodeCount() {
            const objs = this.linesMod.tableData.reduce((prev, next) => {
                if (prev[next.itemCode]) {
                    prev[next.itemCode].qty = BigNumber(prev[next.itemCode].qty || 0).plus(next.singQty || 0).toNumber();
                    prev[next.itemCode].price = BigNumber(prev[next.itemCode].price || 0).plus(next.price || 0).toNumber();
                } else {
                    prev[next.itemCode] = {
                        itemCode: next.itemCode,
                        itemDesc: next.itemDesc,
                        qty: next.singQty || 0,
                        price: next.price || 0,
                    };
                }
                return prev;
                // if (prev.itemCode === next.itemCode) {
                //     prev.qty = BigNumber(prev.qty || 0).plus(next.qty || 0).toNumber();
                //     prev.price = BigNumber(prev.price || 0).plus(next.price || 0).toNumber();
                // }
                // return prev;
            }, {});
            this.summarizingMod.tableData = Object.values(objs);
        },
        deleteLine() {
            this.$Modal.confirm({
                content: this.$t('gscInvoice.t107'), // 确定要删除吗？
                onOk: () => {
                    this.deletedLineIdList.push(...this.linesMod.selection.map((item) => item.lineId));
                    this.linesMod.tableData = this.linesMod.tableData.filter((item) => !this.linesMod.selection.map((sel) => sel.lineId).includes(item.lineId));
                },
            });
        },
        exportLines(hasData = true) {
            if (this.linesMod.tableData.length === 0 && hasData) return;
            const options = {
                anchor: hasData? 'anchor' : 'anchor2',
                filename: this.$t('commercialInvoice.t17'),
                format: 'xlsx',
            };
            const lines = this.linesMod.columns.filter((item) => item.key && (!hasData ? !['unitPrice', 'price'].includes(item.key) : true));
            const columns = lines.map((item) => item.title);
            const columnsKeys = lines.map((item) => item.key);
            let datas = [];
            if (hasData) {
                datas = this.linesMod.tableData.reduce((prev, next, index) => {
                    prev[index] = [];
                    for (let i in columnsKeys) {
                        if (columnsKeys[i] === 'invoiceDate') {
                            next[columnsKeys[i]] = next[columnsKeys[i]] ? next[columnsKeys[i]].split(' ')[0] : '';
                        }
                        prev[index].push(next[columnsKeys[i]])
                    }
                    return prev;
                }, []);
            }
            const sheets = [
                {
                    name: this.$t('commercialInvoice.t17'),
                    from: {
                        array: [
                            columns,
                            ...datas,
                        ],
                    },
                },
            ];
            ExcellentExport.convert(options, sheets);
        },
        importUploadProgress() {
            this.importModal.loading = true;
        },
        async importUploadSuccess(res) {
            this.importModal.loading = false;
            const { code, datas, msg: content } = res.data;
            if (code === '1') {
                // datas.some((item) => item.invoiceDate)
                if (!datas.some(this.isValidDate)) {
                    this.$Modal.warning({
                        content: this.$t('请检查发票日期是否正确，格式是否为YYYY-MM-DD或YYYY/MM/DD'),
                    });
                    return;
                }
                datas.map((item, index) => {
                    Object.assign(item, {
                        invoiceNumber: item.invoiceNumber || '',
                        invoiceDate: item.invoiceDate || '',
                        singQty: !this.decimalPlaceRestrictionRule.test(item.singQty) ? (+item.singQty).toFixed(6) : item.singQty,
                        copperPrice: !this.decimalPlaceRestrictionRule.test(item.copperPrice) ? (+item.copperPrice).toFixed(6) : item.copperPrice,
                        fabricationFee: !this.decimalPlaceRestrictionRule.test(item.fabricationFee) ? (+item.fabricationFee).toFixed(6) : item.fabricationFee,
                        lineId: Date.now() + index,
                        unitPrice: 0,
                        price: 0,
                    });
                    return item;
                });
                this.linesMod.tableData.unshift(...datas);
                await this.queryFabricationFee(Array.from(new Set([...this.linesMod.tableData.map((item) => item.itemCode)])));
                this.importModal.show = false;
                this.$nextTick(() => {
                    this.linesMod.tableData.forEach((item, index) => {
                        this.countFun(index, item);
                    });
                    this.itemCodeCount();
                });
            } else {
                this.$Modal.warning({
                    content,
                });
            }
            this.$refs.importUploadFileRef.clearFiles();
        },
        importTemplate() {
            this.exportLines(false);
        },
        importFun() {
            this.$refs.fromRef.validate((valid) => {
                if (valid) {
                    this.importModal.show = true;
                }
            });
        },
        onSelectionChange(selection) {
            this.linesMod.selection = selection;
        },
        copyLine() {
            const data = this.linesMod.tableData[0];
            this.linesMod.tableData.push({
                ...data,
                lineId: Date.now(),
                isNew: true,
            });
            this.itemCodeCount();
        },
		/* 根据物料编码查询上一次加工费 */
        queryFabricationFee(itemCodeList) {
            return axios.post('/gscint/cgzxInvoice/queryFabricationFee', {
                organizationCode: this.invoiceForm.organizationCode,
                vendorCode: this.vendorCode,
                itemCodeList,
            })
                .then((res) => {
                    debugger;
                    const { code, data } = res.data.data;
                    if (code === 1) {
                        if (data.length > 0) {
                            this.linesMod.tableData.forEach((item, index) => {
                                const obj = data.find((i) => item.itemCode === i.itemCode);
                                if (obj) {
                                    if (!item.fabricationFee && item.fabricationFee !== 0) {
                                        item.fabricationFee = obj.fabricationFee;
                                        this.countFun(index, item);
                                        this.itemCodeCount();
                                    }
                                }
                            });
                        }
                    }
                });
        },
        /* 品牌产地 */
        getBrandPlaceInfo(itemCodeList) {
            this.brandModal.loading = true;
            axios.post('/srmpos/brandPlaceRelats/getBrandPlaceInfo', {
                vendorCode: this.vendorCode,
                organizationCode: this.invoiceForm.organizationCode,
                itemCodeList,
            })
                .then((res) => {
                    this.brandModal.tableData = res.data?.data?.data || [];
                    this.brandModal.tableData.forEach((item) => {
                        const place = this.INT_ORIGIN.find((dict) => dict.attribute1 === item.place)?.label;
                        if (place) {
                            item.place = place;
                        }
                    });
                })
                .finally(() => {
                    this.brandModal.loading = false;
                });
            // this.brandModal.tableData = [
            //     {
            //         "brandName": "盈特",
            //         "brandPlace": "盈特-佛山",
            //         "itemCode": "12222000007564",
            //         "place": "CN",
            //         "categoryCode": "CP201403120974",
            //         "brandBelongCountry": "CN"
            //     }
            // ]
        },
        brandRowClick(row) {
            this.brandModal.row = row;
        },
        brandConfirm() {
            const { index, row } = this.brandModal;
            const line = this.linesMod.tableData[index];
            line.brand = row.brandName;
            line.origin = row.place;
            Object.assign(this.brandModal, {
                show: false,
                row: null,
            });
        },
        isValidDate({ invoiceDate: dateString }) {
            // 检查格式是否为 YYYY-MM-DD 或 YYYY/MM/DD
            const regex = /^\d{4}[-\/](0[1-9]|1[0-2])[-\/](0[1-9]|[12][0-9]|3[01])$/;
            if (!regex.test(dateString)) {
                return false;
            }
            // 提取年月日
            const separator = dateString[4]; // 获取分隔符（- 或 /）
            const parts = dateString.split(separator);
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10);
            const day = parseInt(parts[2], 10);
            // 检查日期是否有效
            const date = new Date(year, month - 1, day);
            return (
                date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
            );
        },
    },
    mounted() {
        if (!this.headerId) {
            const { vendorCode = '', vendorName = '' } = JSON.parse(localStorage.getItem('supplierInfo')) || {};
            Object.assign(this.invoiceForm, {
                vendorCode,
                vendorName,
            });
        }
        this.getDict('INT_ORIGIN');
    },
    activated() {
        if (this.headerId) {
            this.queryDetail(this.headerId);
        }
    },
};
</script>
<style lang="less" scoped>
.layout {
    padding: 20px;
    background: #FFF;
}
.mt10 {
    margin-top: 10px;
}
.ml10 {
    margin-left: 10px;
}
.w600 {
    width: 600px;
}
</style>
